export default {
  setGenres(state, value) {
    state.genres = value;
  },
  setSchools(state, value) {
    state.schools = value;
  },
  setSchoolsLoading(state, value) {
    state.schoolsLoading = value;
  },
  setSchoolsError(state, value) {
    state.schoolsError = value;
  },
  setEvents(state, { events, total }) {
    state.events = events;
    state.eventsTotal = total;
  },
  setEventsLoading(state, value) {
    state.eventsLoading = value;
  },
  setEventSearch(state, value) {
    state.eventSearch = value;
  },
  setEventSearchLoading(state, value) {
    state.eventSearchLoading = value;
  },
  setEventSearchError(state, value) {
    state.eventSearchError = value;
  },
  setTodayClasses(state, value) {
    state.todayClasses = value;
  },
  setCurrentSchool(state, value) {
    state.currentSchool = value;
  },
  setCurrentEvent(state, value) {
    state.currentEvent = value;
  },
  setCurrentOrganizer(state, value) {
    state.currentOrganizer = value;
  },
  setDetailLoading(state, value) {
    state.detailLoading = value;
  },
  setDetailError(state, value) {
    state.detailError = value;
  },
};
